<credentials-table type="DEVICE"></credentials-table>
